export const PUBLIC_IMAGES: string = "publicImages";
export const AUTH_TOKEN: string = "authToken";
export const LOGIN_TOGGLE: string = "logginToggle";
export const IS_LOGGED_IN: string = "isLoggedIn";
export const USER_USERNAME: string = "userUsername";
export const USER_FULL_NAME: string = "userFullName";
export const USER_IDENTITY: string = "userIdentity";
export const PROJECT_SETTINGS: string = "projectSettings";
